export default "__VITE_ASSET__e3f74107__"